module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2a67a36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Footer.vue
// module id = 107
// module chunks = 0